import {Component, EventEmitter, forwardRef, inject, Input, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR, ReactiveFormsModule} from '@angular/forms';
import {ImagesService} from '../../../services/general/images.service';
import {NgStyle} from '@angular/common';

@Component({
  selector: 'app-custom-input',
  imports: [
    NgStyle,
    ReactiveFormsModule,
  ],
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputComponent),
      multi: true
    }
  ]
})
export class CustomInputComponent {
  _images = inject(ImagesService);

  @Input() label: string = '';
  @Input() showLabel: boolean = false;
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() selectValue: string = '';
  @Input() showAsteric: boolean = false;
  @Input() readonly: boolean = false;
  @Input() maxlength: number | null = null;
  @Input() prefixIcon: string = '';
  @Input() showPrefixIcon: boolean = false;
  @Input() suffixIcon: string = '';
  @Input() showSuffixIcon: boolean = false;
  @Input() icon: string = '';
  @Input() iconBackgroundColor: string = '#567DD9';
  @Input() inputBackgroundColor: string = '#d2e0ff40';
  @Input() isRequired: boolean = false;
  @Input() max: string = '';
  @Input() isTextarea: boolean = false;
  @Input() rows: number = 4;
  @Output() valueChange = new EventEmitter<string>();
  @Output() selectValueChange = new EventEmitter<string>();

  value: string = '';
  isDisabled: boolean = false;
  showPassword: boolean = false;

  // ControlValueAccessor implementation
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(event: Event): void {
    const element = event.target as HTMLInputElement | HTMLTextAreaElement;
    this.value = element.value;
    this.onChange(this.value);
    this.onTouched();
    this.valueChange.emit(this.value);
  }

  togglePassword(): void {
    this.showPassword = !this.showPassword;
    this.type = this.showPassword ? 'text' : 'password';
  }

  ngOnInit(): void {
    if (this.selectValue) {
      this.selectValueChange.emit(this.selectValue);
    }
  }
}

